import styled from "styled-components";

export const CloseBackground = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 90;
  background: #00000059;
`;
export const AttachPopupWrapper = styled.div`
  position: fixed;
  bottom: 0px;
  left: 0;
  right: 0;
  top: 80%;
  z-index: 100;
  background: ${(props) => props.theme.serviceDeskMainBackground};
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
  box-shadow: 0px 0.15px 0.45px 0px rgba(0, 0, 0, 0.11),
    0px 0.8px 1.8px 0px rgba(0, 0, 0, 0.13);
`;

export const AttachTitle = styled.h1`
    font-size: 17px;
    font-weight: 600;
    line-height: 22px;
    text-align: center;
    letter-spacing: -0.43px;
    padding: 16px;
    font-style: normal;
`;

export const AttachOptionsWrapper = styled.div`
    display: flex;
    flex-direction: column;
    gap: 8px;
    padding: 0px 12px 0px 12px;
`;

export const AttachOption = styled.div`
    display: flex;
    flex-direction: row;
    font-weight: 400;
    font-size: 14px;
    line-height: 20px;
`;